module.exports = __webpack_public_path__ + "img/HeroTypesQuiz_Speedster.d20f4f2b.png";